var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4163 2.88223L15.1177 5.58373C15.3181 5.7841 15.4771 6.02198 15.5856 6.28379C15.694 6.5456 15.7499 6.82622 15.7499 7.1096C15.7499 7.39299 15.694 7.6736 15.5856 7.93541C15.4771 8.19722 15.3181 8.43511 15.1177 8.63548L13.1355 10.6177C12.9351 10.8181 12.6972 10.9771 12.4354 11.0856C12.1736 11.194 11.893 11.2498 11.6096 11.2498C11.3262 11.2498 11.0456 11.194 10.7838 11.0856C10.522 10.9771 10.2841 10.8181 10.0837 10.6177L9.858 10.392L4.9395 15.3105C4.69029 15.5596 4.36131 15.7131 4.01025 15.744L3.879 15.75H3C2.8163 15.75 2.639 15.6825 2.50172 15.5604C2.36444 15.4384 2.27674 15.2702 2.25525 15.0877L2.25 15V14.121C2.25009 13.7688 2.37408 13.4279 2.60025 13.158L2.6895 13.0605L3 12.75H4.5V11.25H6V9.74998L7.608 8.14198L7.38225 7.91623C7.18185 7.71586 7.02288 7.47797 6.91442 7.21616C6.80597 6.95435 6.75014 6.67374 6.75014 6.39035C6.75014 6.10697 6.80597 5.82635 6.91442 5.56454C7.02288 5.30273 7.18185 5.06485 7.38225 4.86448L9.3645 2.88223C9.56487 2.68183 9.80275 2.52286 10.0646 2.4144C10.3264 2.30594 10.607 2.25012 10.8904 2.25012C11.1738 2.25012 11.4544 2.30594 11.7162 2.4144C11.978 2.52286 12.2159 2.68183 12.4163 2.88223Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75H11.2575",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.4dcaa23b3601b95c82d7f9476858cdd9.svg";
export { ForwardRef as ReactComponent };